export const pricingPlans = [
  {
    id: 'free',
    name: 'Consultant',
    description: 'For independent inspectors.',
    monthlyPrice: 0,
    annualPrice: 0,
    features: [
      '1 Active Project Site',
      'Unlimited Inspections',
      'Basic Reporting'
    ],
    cta: 'Start for Free',
    popular: false,
    highlight: false,
  },
  {
    id: 'solo',
    name: 'Pro',
    description: 'For growing firms.',
    monthlyPrice: 49,
    annualPrice: 490,
    features: [
      '5 Active Project Sites',
      'Weather Captured on Inspections',
      'Priority Support'
    ],
    cta: 'Choose Pro',
    popular: true,
    highlight: true,
  },
  {
    id: 'pro',
    name: 'Business',
    description: 'For established teams.',
    monthlyPrice: 99,
    annualPrice: 990,
    features: [
      '15 Active Project Sites',
      'Team Roles',
      'Audit Logs'
    ],
    cta: 'Choose Business',
    popular: false,
    highlight: false,
  },
  {
    id: 'scale',
    name: 'Enterprise',
    description: 'For large GCs & developers.',
    monthlyPrice: 199,
    annualPrice: 1990,
    features: [
      'Unlimited Sites',
      'Unlimited Users',
      'API Access',
      'Dedicated Support'
    ],
    cta: 'Choose Enterprise',
    popular: false,
    highlight: false,
  },
];

export const pricingFaqs = [
  {
    question: "Does 'Unlimited Inspections' apply to the free plan?",
    answer: "Yes. You can perform as many inspections as required on your single active project site."
  },
  {
    question: "Can I archive sites when a project ends?",
    answer: "Yes. Archived sites do not count towards your active site limit, but their data is retained for your records."
  },
  {
    question: "Do you offer bulk discounts?",
    answer: "Yes, for organizations managing over 50 active sites, please contact sales for volume pricing."
  }
];
